import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Paginator} from "../../../models/paginator";
import {Utils} from "../../../utils";
import {FieldService, FieldServiceType, UserFieldServiceAssignment} from '../../../models/field-service';
import {FieldServiceManagerService} from "../../../services/field-service-manager.service";
import {environment} from "@environments/environment";

export interface BindFieldServiceDialogData {
  isNew: boolean;
  currentUserFieldServiceAssignment: UserFieldServiceAssignment;
  userFieldServiceAssignments: UserFieldServiceAssignment[];
}

@Component({
  selector: 'app-bind-field-service-dialog',
  templateUrl: './bind-field-service-dialog.component.html',
  styleUrls: ['./bind-field-service-dialog.component.scss']
})
export class BindFieldServiceDialogComponent implements OnInit {

  isLoading: boolean;

  /* Search field service */
  fieldServiceFilter: string;
  filteredFieldServices: FieldService[];
  fieldServices: FieldService[];

  fieldServiceId: string;
  isManager: boolean;

  constructor(
    public dialogRef: MatDialogRef<BindFieldServiceDialogComponent>,
    private fieldServiceManagerService: FieldServiceManagerService,
    @Inject(MAT_DIALOG_DATA) public data: BindFieldServiceDialogData) {

    // Init field service assignment if required
    if (this.data.isNew) {
      this.data.currentUserFieldServiceAssignment = new UserFieldServiceAssignment();
      this.isManager = false;
    } else {
      this.fieldServiceId = this.data.currentUserFieldServiceAssignment.fieldService.id;
      this.isManager = this.data.currentUserFieldServiceAssignment.isManager;
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    await this.fetchFieldServices()
    this.isLoading = false;
  }

  async fetchFieldServices() {
    this.fieldServices = await this.fieldServiceManagerService.getFieldServices(null, new Paginator<FieldService>({ignorePagination: true}));
    this.filteredFieldServices = this.fieldServices;
  }

  onFieldServiceChange() {
    // Check if is manager of this field service
    const previouslyAssignedFieldService = this.data.userFieldServiceAssignments.find(x => x.fieldService.id == this.fieldServiceId);
    if (previouslyAssignedFieldService) {
      this.isManager = previouslyAssignedFieldService.isManager;
    } else {
      this.isManager = false;
    }
  }

  validate() {
    return !Utils.isEmpty(this.fieldServiceId);
  }

  get finalData(): BindFieldServiceDialogData {
    this.data.currentUserFieldServiceAssignment.isManager = this.isManager;
    this.data.currentUserFieldServiceAssignment.fieldService = this.fieldServices.find(fieldService => fieldService.id === this.fieldServiceId);
    return this.data;
  }

  get environment() { return environment }

}
